import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/calendar/page.client.tsx");
